import {GraphRange, SyntheticMarketData} from '@shareland/shareland-common';

export type SyntheticMarketDataRange = keyof SyntheticMarketData['marketPrice'];

export const syntheticMarketDataRangeToGraphDateType = (range: SyntheticMarketDataRange): GraphRange => {
  switch (range) {
    case 'daily':
      return 'day';
    case 'monthly':
      return 'month';
  }
};
